module.exports = Em.Component.extend({
    layoutName: 'components/signup-welcome-modal',

    modalVariant: 'mobileSignupWelcomeModal',

    userOrganizations: Em.inject.service(),

    organization: Em.computed.oneWay('userOrganizations.activeOrganization')
})
